export interface IQuizState {
	questions: unknown[];
}

export const defaultState = (): IQuizState => ({
	questions: []
});

export default defaultState;
